export default "__VITE_ASSET__aCCoIEMk__"